import './index.scss'
$("header .nav li").eq(2).addClass("active");
$(".nei-nav ul li").eq(1).addClass("active");
$(function () {
    var navHeight = $("header").height()
    $(window).scroll(function () {
        // 可是窗口滚动条发生滚动的时候 垂直方向滚动到多少距离的时候 让头部导航条设置上一个固定定位的样式
        if ($(window).scrollTop() > ($(".nei-banner").height() + navHeight ) && ($(window).scrollTop() < $(".solution").height() + navHeight )) {
            $(".solution-nav ul").addClass("fixed");
        }
        else {
            $(".solution-nav ul").removeClass("fixed");
        }
    })
})
$(".content-nav a").eq(0).addClass("active");
$(".content-box .content1").eq(0).addClass("active");
$(".content-nav a").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass('active')
    $(".content-box .content1").eq(index).addClass("active").siblings().removeClass('active')
})